import React from 'react';
import { Device } from 'src/common';
import { Stepper, type StepperProps } from 'src/components/Stepper/Stepper';
import { Progress } from 'src/components/progress';

import styled from 'styled-components';

const Tablet = styled.div`
  @media screen and (min-width: ${Device.Tablet}) {
    display: none;
  }
`;

const Desktop = styled.div`
  @media screen and (max-width: ${Device.Tablet}) {
    display: none;
  }
`;

export const Wizard: React.FC<StepperProps> = (props) => {
  return (
    <>
      <Desktop>
        <Stepper {...props} />
      </Desktop>
      <Tablet>
        <Progress {...props} />
      </Tablet>
    </>
  );
};
